import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { z } from 'zod';
import { UserFormValues } from './types';

const createSchema = (t: TFunction<readonly ['users', 'common']>, isCreating: boolean) => {
  const baseSchema = z.object({
    firstName: z
      .string()
      .min(1, t('common:required'))
      .max(100, t('common:maxLength', { count: 100 })),
    lastName: z
      .string()
      .min(1, t('common:required'))
      .max(100, t('common:maxLength', { count: 100 })),
    middleName: z
      .string()
      .max(100, t('common:maxLength', { count: 100 }))
      .optional()
      .or(z.literal('')),
    email: z.string().min(1, t('common:required')),
    roleCode: z.string().min(1, t('common:required')),
    isActive: z.boolean(),
    userGroups: z.array(z.object({ id: z.number() })),
  }) satisfies z.ZodType<Omit<UserFormValues, 'password'>>;

  if (isCreating) {
    return baseSchema.extend({
      password: z.string().min(1, t('common:required')),
    }) satisfies z.ZodType<UserFormValues>;
  }

  return baseSchema satisfies z.ZodType<Omit<UserFormValues, 'password'>>;
};

export const useUserSchema = (isCreating: boolean) => {
  const { t } = useTranslation(['users', 'common']);

  return createSchema(t, isCreating);
};
